<template>
  <!-- SECTION Incidences-->
  <div id="incidencesSection" class="row col-12 m-0 p-0" v-if="!display.configurationView">
    <div class="row col-12 p-0 m-0 section-container justify-content-center">

      <div class="col-lg-12 col-md-12 col-12 m-0 overflow-hidden justify-content-center bg-white rounded-5 p-0">
        <div class="row col-lg-12 col-md-12 col-12 table-responsive m-0 p-0">

          <div class="position-sticky col-12 m-0 p-0 ps-4 bg-head text-white text-start border-1">
            <div class="row p-0 m-0">
              <!--Primera sección-->
              <div class="row col-lg-10 col-md-10 col-12 m-0 pt-0 ps-3 pe-4 text-white rounded-5 rounded-end">
                <div
                  class="col-xl-3 col-lg-4 col-md-6 col-12 m-0 mb-1 mt-1 pt-0 ps-0 text-white justify-content-end d-flex flex-nowrap">
                  <h6 class="tx-left text-white tx-14 text-center mt-1 mb-1 ps-1 pt-1 text-nowrap me-3">
                    <ion-icon name="location" class="tx-18 me-2 align-bottom"></ion-icon>
                    {{ dictionary["Empresas"][session.user.language] }}
                  </h6>
                  <select
                    v-if="this.$route.params.currentDisplay === 'machines' || this.$route.params.currentDisplay === 'commandCenters' || this.targetEmplacementId == ''"
                    :value="currentCompany.nifCif" class="form-control m-0 p-0 text-nowrap bg-white border me-3"
                    style="border: solid 2px white ; color: black; min-width:120px; max-width: 180px; max-height:34px;"
                    @change="onCurrentCompanyChanged">
                    <option v-if="availableCompanies[0] != undefined && availableCompanies.length > 1" value="showAll">
                      {{
                        dictionary['Mostrar todo'][session.user.language] }} </option>
                    <option v-for="company in availableCompanies" :key="company.nifCif" :v-if="company.nifCif != session.user.nifCif
                      && company.relation != undefined
                      && company.relation.referenceCompany === this.session.user.nifCif" :value="company.nifCif">
                      {{ (company.nifCif === session.user.nifCif) ? "✪ " + company.name : company.name }}
                    </option>
                  </select>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-5 col-12 m-0 mb-1 mt-1 pt-0 ps-0 text-white justify-content-end d-flex flex-nowrap">
                  <select v-if="this.$route.params.currentDisplay === 'commandCenters'" :value="targetEmplacementId"
                    class="form-control m-0 p-0 text-nowrap bg-white border me-3"
                    style="border: solid 2px white ; color: black;  min-width:120px; max-width: 180px; max-height:34px;"
                    @change="onEmplacementChanged">
                    <option v-for="emplacement in emplacementList" :key="emplacement.nifCif" :value="emplacement.id">
                      {{ emplacement.label }}
                    </option>
                  </select>
                  <!-- Label for the select element -->
                  <ion-icon name="warning-outline" class="tx-18 me-2 pt-2 align-bottom"></ion-icon>
                  <!--<label for="incidenceSelect" class="form-label text-start mb-2 pt-2 tx-14 me-3">{{ dictionary['Incidencia'][session.user.language] }}</label>-->
                  <select v-if="incidenceList" v-model="selectedIncidence" id="incidenceSelect"
                    class="form-control m-0 p-0 text-nowrap bg-white border me-3"
                    style="border: solid 2px white; color: black; min-width:120px; max-width: 180px; max-height:34px;"
                    @change="onSelectedIncidence($event.target.value)">
                    <option value="all">{{ dictionary['Todos'][session.user.language] }}</option>
                    <option v-for="incidence in incidenceList" :key="incidence.id" :value="incidence.id">
                      {{ incidence.label }}
                    </option>
                  </select>
                </div>
                <div
                  class="col-xl-4 col-lg-5 col-md-7 col-12 m-0 mb-1 mt-1 pt-0 ps-0 text-white justify-content-end d-flex flex-nowrap">
                  <!--<ion-icon name="calendar-outline"></ion-icon>-->
                  <label for="incidenceSelect"
                    class="form-label text-start tx-14 pt-2 me-2 mb-2 text-nowrap"><!--{{ dictionary['Fecha inicio'][session.user.language] }}-->
                    Inicio/Fin
                  </label>
                  <input type="date" v-if="incidenceList" class="dateInput form-control tx-11 rounded text-nowrap me-3"
                    style="border: solid 2px white ; max-width: 120px; max-height:34px;"
                    v-model="historicSearchFilter.StartDate" @change="onSelectedStartDate($event.target.value)">
                  <!--<label for="incidenceSelect" class="form-label text-start tx-14 pt-2 me-2 mb-2">{{ dictionary['Fecha fin'][session.user.language] }}</label>-->
                  <input type="date" v-if="incidenceList" class="dateInput form-control tx-11 rounded text-nowrap me-3"
                    style="border: solid 2px white ; max-width: 120px; max-height:34px;"
                    v-model="historicSearchFilter.EndDate" @change="onSelectedEndDate($event.target.value)">
                </div>
                <div
                  class="col-xl-1 col-lg-1 col-md-3 col-12 m-0 mb-1 mt-1 p-0 text-white justify-content-end d-flex flex-nowrap">
                  <button id="btnDisplayNewMachineModal" type="button"
                    class="text-dark m-0 p-0 bg-white border rounded-5 shadow" @click="searchSelectedFilter"
                    style="max-width: 120px !important; height: 34px;">
                    <span class="button-text">
                      <!--<ion-icon name="search-circle-outline" class="text-dark p-0 m-0 pt-1 me-2 tx-18 hydrated md"></ion-icon>-->
                      <span class="text-dark m-0 p-0 text-nowrap">{{ dictionary["Buscar"][session.user.language]
                        }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <!-- Fin Primera sección-->
              <!--Segunda sección-->
              <div class="col text-end p-0 m-0 mb-1 pt-2 pe-3" style="width: 160px !important;">
                <button id="btnDisplayNewIncidencesModal" style="width: 30px; max-height: 30px;"
                  class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow" @click="toggleOpenNewIncidence">
                  <span>
                    <span class="button-text text-white">
                      <ion-icon name="add-circle-outline" class="pt-0 me-0 tx-18 hydrated"></ion-icon>
                      <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                    </span>
                  </span>
                </button>
                <button v-if="editingPermission" id="btnEditIncidence" style="width: 30px; max-height: 30px;"
                  class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow" @click="toggleConfigurationView()">
                  <span>
                    <span class="button-text text-white">
                      <ion-icon name="create-outline" class="pt-0 me-0 tx-18 hydrated"></ion-icon>
                      <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                    </span>
                  </span>
                </button>
                <button style="width: 30px; max-height: 30px;" class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow"
                  @click="refreshView">
                  <span>
                    <span class="button-text text-white">
                      <ion-icon name="refresh-outline" class="pt-0 me-0 tx-16 hydrated"></ion-icon>
                      <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- SECTION historic -->
          <HistoricIncidencesComponent :session="session" :dictionary="dictionary" :countries="countries"
            :visibility="visibility" :currentCompany="currentCompany" :requestedIncidenceId="targetIncidenceId"
            :requestedSearch="this.requestedSearch" :timeZones="timeZones" :requestedIncidenceLabel=targetIncidenceLabel
            :incidenceTypes="incidenceList" :dataTableOptions="dataTableOptions">
          </HistoricIncidencesComponent>

        </div>
      </div>

    </div>
  </div>

  <IncidencesConfigurationComponent v-if="display.configurationView" :session="session" :dictionary="dictionary"
    :countries="countries" :timeZones="timeZones" :visibility="visibility" :currentCompany="currentCompany"
    :availableCompanies="availableCompanies" :dataTableOptions="dataTableOptions"
    v-on:toggleConfigurationView="toggleConfigurationView">
  </IncidencesConfigurationComponent>


  <!-- MODAL New Incidence -->
  <NewIncidenceModal v-if="display.newIncidenceModal" :session="session" :dictionary="dictionary" :countries="countries"
    :timeZones="timeZones" :currentCompany="currentCompany" v-on:toggleNewIncidenceModal="toggleNewIncidenceModal">
  </NewIncidenceModal>

  <!-- MODAL Edit Incidence -->
  <EditIncidenceModal v-if="display.editIncidenceModal" :session="session" :dictionary="dictionary"
    :countries="countries" :timeZones="timeZones" :currentCompany="currentCompany" :incidenceId="targetIncidenceId"
    v-on:toggleEditIncidenceModal="toggleEditIncidenceModal">
  </EditIncidenceModal>

  <!-- MODAL Delete Text Alert -->
  <TextAlertModal v-if="display.deleteIncidenceModal" :session="session" :dictionary="dictionary" :countries="countries"
    :alertHeader="dictionary['Incidencia a eliminar'][session.user.language] + ': '" :alertTarget="targetIncidenceLabel"
    @acceptAlert="confirmDeleteIncidence" @dismissAlert="toggleDeleteIncidenceModal">
  </TextAlertModal>
  <!-- MODAL OpenNewIncidence -->
  <OpenNewIncidenceModal v-if="display.newHistoricModal" :session="session" :dictionary="dictionary"
    :countries="countries" :timeZones="timeZones" :currentCompany="currentCompany"
    :availableCompanies="availableCompanies" :incidenceTypes="incidenceList" :incidenceId="targetIncidenceId"
    v-on:toggleOpenNewIncidence="toggleOpenNewIncidence">
  </OpenNewIncidenceModal>
</template>

<script>

import HistoricIncidencesComponent from '@/components/incidences/HistoricIncidencesComponent';
import NewIncidenceModal from '@/components/incidences/NewIncidenceModal';
import EditIncidenceModal from '@/components/incidences/EditIncidenceModal';
import TextAlertModal from '@/components/other/TextAlertModal';
import OpenNewIncidenceModal from '@/components/incidences/OpenNewIncidenceModal';
import IncidencesConfigurationComponent from '@/components/incidences/IncidencesConfigurationComponent';
// Clomos
import api from '@/services/api';

export default {
  name: "IncidencesComponent",
  components: { OpenNewIncidenceModal, HistoricIncidencesComponent, NewIncidenceModal, EditIncidenceModal, TextAlertModal, IncidencesConfigurationComponent },
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      required: true,
    },
    visibility: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
    availableCompanies: {
      type: Object,
      required: true,
    },
    targetEmplacementId: {
      type: String,
      required: true,
    },
    dataTableOptions: {
      type: Object,
      required: true,
    }
  },
  watch: {
    targetIncidenceId: async function () {

      this.clearDates();

    },
    targetEmplacementId: async function () {
      if (this.$route.params.currentDisplay === 'incidences' || this.targetEmplacementId == '') {
        await this.getIncidencesByCompany();
      }

    },
    currentCompany: async function () {
      this.historicSearchFilter.StartDate =
        await this.getEmplacementList();
      if (this.$route.params.currentDisplay === 'incidences') {
        await this.getIncidencesByCompany();
      }
      this.$emit('getAvailableCompanies');
      const dates = this.displayDates();
      this.historicSearchFilter.StartDate = dates.sevenDaysAgo;
      this.historicSearchFilter.EndDate = dates.today;
    }
  },
  data() {
    return {
      selectedIncidence: 'all',
      requestedSearch: {

      },
      targetEmplacementData: {},
      targetIncidenceId: "",
      targetIncidenceLabel: "",
      incidenceList: [],
      emplacementList: [],
      display: {
        newIncidenceModal: false,
        configurationView: false
      },
      displayHistoricIncidence: false,
      historicSearchFilter: {},
      selectedCompany: "",
      editingPermission: false
    }

  },

  emits: ["setCurrentCompany", "getAvailableCompanies", "handleHasRol"],
  methods: {
    // DISPLAY
    onSelectedIncidence(value) {
      this.targetIncidenceId = value;
      this.targetIncidenceLabel = this.incidenceList.find(incidence => incidence.id === this.targetIncidenceId)?.label || "";
      const timeZone = this.session.user.dateTimeZone || 'UTC';
      const today = this.$dayjs().tz(timeZone).format('YYYY-MM-dd');
      const pastWeek = this.$dayjs().tz(timeZone).subtract(7, 'day').format('YYYY-MM-dd');
      this.historicSearchFilter.StartDate = pastWeek;
      this.historicSearchFilter.EndDate = today;
      this.$router.replace({ params: { targetEntity: this.targetIncidenceId } });
    },
    clearDates() {
      this.historicSearchFilter.StartDate = null;
      this.historicSearchFilter.EndDate = null;
    },
    onSelectedStartDate(value) {
      this.historicSearchFilter.StartDate = value
      if (this.historicSearchFilter.EndDate && this.historicSearchFilter.EndDate < this.historicSearchFilter.StartDate) {
        window.alert("la fecha fin tiene que ser igual o mayor a la fecha inicio")
      }
    },
    onSelectedEndDate(value) {
      this.historicSearchFilter.EndDate = value
      if (this.historicSearchFilter.StartDate && this.historicSearchFilter.EndDate < this.historicSearchFilter.StartDate) {
        window.alert("la fecha fin tiene que ser igual o mayor a la fecha inicio")
      }
    },
    resetSelectedIncidence() {
      this.selectedIncidence = ""
    },
    searchSelectedFilter() {
      if (this.historicSearchFilter.StartDate && this.historicSearchFilter.EndDate) {
        this.historicSearchFilter.action = "search";
        this.historicSearchFilter.incidenceId = this.targetIncidenceId;
        this.historicSearchFilter.nifCif = this.currentCompany.nifCif;
        this.requestedSearch = { ...this.historicSearchFilter };
        return this.requestedSearch;
      }
    },
    async onCurrentCompanyChanged(event) {
      let value = event.target.value;
      this.$router.replace({ params: { currentCompanyNifCif: value } })
      this.$emit('setCurrentCompany', value);
      this.selectedCompany = value
      await this.getIncidencesByCompany(this.selectedCompany);
      this.selectedIncidence = 'all'
    },
    async toggleOpenNewIncidence() {
      if (this.display.newHistoricModal) {
        await this.getIncidencesByCompany();
      }
      this.display.newHistoricModal = !this.display.newHistoricModal;
      this.resetSelectedIncidence
    },
    async toggleConfigurationView() {
      if (this.display.configurationView) {
        this.historicSearchFilter.StartDate =
          await this.getEmplacementList();
        if (this.$route.params.currentDisplay === 'incidences') {
          await this.getIncidencesByCompany();
        }
        this.$emit('getAvailableCompanies');
        const dates = this.displayDates();
        this.historicSearchFilter.StartDate = dates.sevenDaysAgo;
        this.historicSearchFilter.EndDate = dates.today;
      }
      this.display.configurationView = !this.display.configurationView;
    },
    async refreshView() {
      this.historicSearchFilter.StartDate =
        await this.getEmplacementList();
      if (this.$route.params.currentDisplay === 'incidences') {
        await this.getIncidencesByCompany();
      }
      this.$emit('getAvailableCompanies');
      const dates = this.displayDates();
      this.historicSearchFilter.StartDate = dates.sevenDaysAgo;
      this.historicSearchFilter.EndDate = dates.today;
    },
    displayDates() {
      const today = new Date();
      today.setDate(today.getDate() + 1);
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 7);

      today.setHours(23, 59, 59, 0);
      sevenDaysAgo.setHours(0, 0, 0, 0);

      const toISOStringFixed = (date) => {
        return date.getFullYear() + '-' +
          String(date.getMonth() + 1).padStart(2, '0') + '-' +
          String(date.getDate()).padStart(2, '0');
      };

      return {
        today: toISOStringFixed(today),
        sevenDaysAgo: toISOStringFixed(sevenDaysAgo)
      };
    },
    // GET
    async getEmplacementList(callback) {
      let request = {
        nifCif: this.currentCompany.nifCif ? this.currentCompany.nifCif : this.session.user.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getEmplacementList(request);
      this.emplacementList = api.parseEmplacementsFromResponse(response);
      if (callback && typeof callback === "function") callback(this.emplacementList);
    },
    async getIncidencesByCompany(company) {

      let request = {
        nifCif: company ? company : this.selectedCompany ? this.selectedCompany : this.currentCompany ? this.currentCompany.nifCif : this.session.user.nifCif,
        limit: 0,
        offset: 0,

      };
      let response = await api.getIncidencesByCompany(request);
      this.incidenceList = api.parseIncidenceListFromResponse(response);
      if (this.incidenceList.length > 0) this.displayHistoricIncidence = true
    },

    async getEmplacementData(callback) {
      let response = await api.getEmplacementData(this.targetEmplacementId);
      this.targetEmplacementData = api.parseEmplacementFromResponse(response);
      if (callback && typeof callback === "function") callback(this.targetEmplacementData);
    },

    // SET 
    onEditIncidence(event) {
      console.log('SHOW WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetIncidenceId = event.target.getAttribute('data-id');
      this.targetIncidenceLabel = this.incidenceList.find(incidence => incidence.id === this.targetIncidenceId)?.label || "";
      this.$router.replace({ params: { targetEntity: this.targetIncidenceId } })
      this.toggleEditIncidenceModal();
    },

    // DELETE
    async confirmDeleteIncidence() {
      try {
        let response = await api.deleteIncidence(this.targetIncidenceId);
        if (response["status-code"] === "200") {
          window.alert("La incidencia ha sido eliminado satisfactoriamente.");
        } else {
          throw new Error("Error al eliminar la incidencia.");
        }
      } catch (error) {
        window.alert(error.message);
      } finally {
        await this.toggleDeleteIncidenceModal();
      }
    },
    checkEditingRoleCallback(hasPermission) {
      this.editingPermission = hasPermission;
    }

  },
  async created() {
    this.historicSearchFilter.StartDate =
      await this.getEmplacementList();
    if (this.$route.params.currentDisplay === 'incidences') {
      await this.getIncidencesByCompany();
    }
    this.$emit('getAvailableCompanies');
    const dates = this.displayDates();
    this.historicSearchFilter.StartDate = dates.sevenDaysAgo;
    this.historicSearchFilter.EndDate = dates.today;
  },
  mounted() {
    this.$emit("handleHasRol", "editor", this.checkEditingRoleCallback);
  }
}
</script>

<style></style>